import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link, useNavigate, useParams } from "react-router-dom";
import { getExhibitorData,doExhibitorUpdate } from '../../Service';
import Swal from "sweetalert2";

export default function ExhibitorEdit() {
    let params = useParams();
    const navigation = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const initialValues = { name: "", address1: "", website: "", primary_contact_full_name: "", email: "", status: "" };
    const [exhibitorData, setExhibitorData] = useState(initialValues);

    useEffect(() => {
        if (!params) {
            navigation("/list");
        }

        getExhibitorData(params.id).then(res => handleResponse(res))
    }, []);



    const handleResponse = (response) => {

        //console.log('Exhibitor Listing',response.data.code)
        if (response.data.code == 200) {
            setExhibitorData(response.data.data);
            //dress1, website: response.data.data.website, primary_contact_full_name: response.data.data.website, email: response.data.data.email, status: response.data.data.status};
        } else {
            let errors = {};
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: response.data.message,
            })
            navigation("/list");
        }
    }



    const handleChange = (e) => {
        let value = e.target.value;
        let field = e.target.name;
        setExhibitorData(prevState => ({
            ...prevState,
            [field]: value
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let errorCount = validate(exhibitorData);
        setFormErrors(errorCount);
        if(errorCount.status1){
            doExhibitorUpdate(exhibitorData).then(res => handleResponseUpdate(res))
        }
    }

    const handleResponseUpdate = (response) => {
        if(response.data.code==200){  //IF Request is Success
            Swal.fire({
                icon: 'success',
                title: 'Exhibitor',
                text: response.data.message,
              })
              navigation("/list");
        } else { //IF Token Expired......
            let errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
        } 
    }

    const validate = (values) => {
        let errors = {};
        let website_regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
        errors.status1 = true;
        
        var error_val = 0;
        if (values.name === '') {
            errors.name = 'Gallery Name is required';
            error_val = 1;
        }
        if (values.address1 === '') {
            errors.address1 = 'Address 1 is required';
            error_val = 1;
        }
        /*if (values.website!=='' && website_regex.test(values.website)) {
            errors.website = "Please enter a valid website!";
            error_val = 1;
        }*/
        if (values.primary_contact_full_name === '') {
            errors.primary_contact_full_name = 'Primary Contact Name is required';
            error_val = 1;
        }
        if (values.status === '') {
            errors.status = 'Status is required';
            error_val = 1;
        }
        

        if (error_val === 1) {
            errors.status1 = false;
        } else {
            errors.status1 = true;
        }
        return errors;
    }

    
    return (
        <section className="admin-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="admin-edit">
                            <h1>Exhibitor Edit</h1>
                            <Form>
                                <Form.Group>
                                    <Form.Label> Name <span className='star'>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="Name" name="primary_contact_full_name" defaultValue={exhibitorData.primary_contact_full_name} onChange={handleChange} />
                                    <p className="error">{formErrors.primary_contact_full_name}</p>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>Address<span className='star'>*</span></Form.Label>
                                    <Form.Control as="textarea" rows={3} placeholder="Address" name="address1" defaultValue={exhibitorData.address1} onChange={handleChange} />
                                    <p className="error">{formErrors.address1}</p>
                                </Form.Group>

                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Email <span className='star'>*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Email" defaultValue={exhibitorData.email} disabled="true" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Gallery Name<span className='star'>*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Gallery Name" name="name" defaultValue={exhibitorData.name} onChange={handleChange} />
                                            <p className="error">{formErrors.name}</p>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Website<span className='star'>*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Website" name="website" defaultValue={exhibitorData.website} onChange={handleChange} />
                                            <p className="error">{formErrors.website}</p>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Status<span className='star'>*</span></Form.Label>
                                            <Form.Select value={exhibitorData.status} name="status" onChange={handleChange} disabled="true">
                                                <option value="">Select</option>
                                                <option value="Pending">Pending</option>
                                                <option value="Approved">Approved</option>
                                            </Form.Select>
                                            <p className="error">{formErrors.status}</p>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <hr />
                                <div className='text-center'>
                                    <Button variant="submit" className='common-btn' onClick={handleSubmit}>Submit</Button> {''}
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}